<template>
  <footer>
    <div class="footer_wrapper">
      <div class="bank_info">
        <div class="footer_logo">
          <img src="../../assets/images/common/footer_logo.svg" alt="西日本シティ銀行">
          <span>金融機関コード：0190</span>
        </div>
        <p>
          商号等 株式会社西日本シティ銀行登録金融機関 福岡財務支局長（登金）<br>
          第6号 加入協会 日本証券業協会<br>
          一般社団法人金融先物取引業協会
        </p>
      </div>
    </div>
    <div class="copyright"><span>Copyright {{currentYear}} THE NISHI-NIPPON CITY BANK, LTD. All right reserved.</span></div>
  </footer>
</template>

<script>
import 'dayjs/locale/ja';
import dayjs from 'dayjs';

export default {
  name: 'Footer',
  components: {
  },
  directives: {
  },
  props: {
  },
  data() {
    return {
      currentYear: dayjs().year()
    };
  },
  methods: {
  },
  mounted: function() {
  }
}
</script>
<style lang="scss" scoped>
footer {
  border-top: 1px solid #f0f0f0;
  background: #FFFFFF;
  
  .footer_wrapper {
    padding: 24px 0;
    width: 940px;
    margin: 0 auto;

    @media #{$small} {
      padding: psd(24);
      width: 100%;
      margin: 0;
    }

    .bank_info {
      display: flex;
      justify-content: space-between;
      align-items: center;

      @media #{$small} {
        display: block;
      }

      .footer_logo {
        img {
          display: block;
          width: 162px;
          margin: 0 auto 10px;

          @media #{$small} {
            width: psd(120);
            margin: 0 auto 10px;
          }
        }
    
        span {
          display: block;
          text-align: center;
          color: #707070;
          font-size: 10px;
          line-height: 14px;

          @media #{$small} {
            font-size: psd(10);
            line-height: psd(14);
            margin-bottom: 24px;
          }
        }
      }

      p {
        color: #707070;
        font-size: 11px;
        line-height: 15px;
        text-align: right;

        @media #{$small} {
          margin: 0;
          font-size: psd(10);
          line-height: psd(14);
          text-align: center;
        }

        br:first-of-type {
          @media #{$large} {
            display: none;
          }
        }
      }
    }
  }
  
  .copyright {
    background: $color_orange;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      display: block;
      color: #fff;
      text-align: center;
      font-size: 10px;
      line-height: 14px;

      @media #{$small} {
        font-size: psd(10);
        line-height: psd(14);
      }
    }
  }
}
</style>